'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.directive('blurDeleteAll', function ($parse) {
    return {
      restrict: 'A',
      link: function link($scope, $element, $attr) {
        var deleteAll = true;
        $element.on('blur', function () {
          deleteAll = true;
        });
        $element.on('keydown', function (e) {
          // 用户按了删除键
          if (e.which === 8 && deleteAll) {
            $scope.$apply(function () {
              $parse($attr['ngModel']).assign($scope, '');
            });
          }
          deleteAll = false;
        });
      }
    };
  });
  return app;
};

require('angular');

/**
 * input 失去焦点后 再次删除 直接删除整行 一般用于密码输入框
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/lib/angular1.x-common/directives/blurDeleteAll.js
// module id = 141
// module chunks = 0